import React from 'react';
import {Col, Container, Row, Button} from "react-bootstrap";
import {withTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';

// CSS Files
import './styles.css';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";

class NewOrReturningPlayer extends React.Component {
    render() {
        const { t } = this.props;

        return (
            <div>
                <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton />
                <Container className={"desktop"}>
                    <Row>
                        <Col xs={12} sm={12}>
                            <BulletHeader text={t("registration_page.new_or_returing")}/>
                            <p>{t("registration_page.new_or_returing_alert")}</p>
                        </Col>
                    </Row>
                    <Col xs={12} className={"mb-5"}>
                        <Row className={"mt-5 mb-3"}>
                            <Button xs={12} variant="secondary" className={"w-100 p-5"} onClick={() => {
                                let is_new = false
                                this.submit({is_new: is_new})
                            }}>
                                <h1 className="button-header-text mb-0">{t("registration_page.returning")}</h1>
                                <p className={"text-center"}>{t("registration_page.returning_note")}</p>
                            </Button>
                        </Row>
                        <Row>
                            <Button xs={12} variant="secondary" className={"w-100 p-5"} onClick={() => {
                                let is_new = true
                                this.submit({is_new: is_new})
                            }}>
                                <h1 className="button-header-text mb-0">{t("registration_page.returning_no")}</h1>
                                <p className={"text-center"}>{t("registration_page.returning_no_note")}</p>
                            </Button>
                        </Row>
                    </Col>
                </Container>

            </div>
        );
    }

    submit = (data) => {
        this.props.onSubmit(data);
    }
}

export default withTranslation()(NewOrReturningPlayer);